import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
import TranslationService from "../../Services/Translation/TranslationService";
import Swal from "../../Components/SweetAlert2";
/** Components Import */
import Loading from "../../Components/Loading";
import StepManager from "./HealthInterview/StepManager";
import StepProgress from "./HealthInterview/StepProgress";

function HealthInterview() {
  const navigate = useNavigate();
  const location = useLocation();
  const language = useSelector((state) => state.localStorage.language);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [formData, setFormData] = useState({
    jobDate: "", // 작업 예정일
    siteId: "",
    siteName: "",
    eduId: "",
    constructionTypeList: [],
    constructionTypes: [],
    unitList: [],
    units: [],
    address: "", // 주소
    emergencyPhone: "", // 비상연락처
    highBloodPressure: "", // 최고 혈압
    lowBloodPressure: "", // 최저 혈압
    workExperience: "0", // 경력
    smoking: "0", // 흡연 여부
    drinking: "0", // 음주 여부
    healthCheck: [],
    ppeIssueStatus: [],
    safeAgreement: [],
    pledgeConfirmed: false, // 안전 서약서 동의 여부
  });
  const [step, setStep] = useState(0);
  const totalSteps = 4;
  const stepLabels = ["시작", "건강 면담", "보호구 지급 품목", "안전 서약"];

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      const userData = await IndexedDb.GetUserInfo();
      console.log("userData: ", userData);
      setUserInfo(userData);
      setFormData({
        ...formData,
        siteId: location.state.site?.siteId,
      });
      const searchResult = await Search(userData.userId);
      await Search1("health", searchResult);
      await Search1("ppe", searchResult);
      await Search1("agreement", searchResult);
    } catch (e) {
      console.log("Init error: ", e);
    }
  };

  // 보건 카드 조회
  const Search = async (_param = userInfo.userId) => {
    try {
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.HealthSafety, {
        companyCode: location.state.company?.companyCode,
        siteId: location.state.site?.siteId,
        empId: _param,
      });
      console.log("Search response: ", response.data);

      if (!response) {
        setFormData({
          jobDate: "", // 작업 예정일
          siteId: "",
          siteName: "",
          eduId: "",
          constructionTypeList: [],
          constructionTypes: [],
          unitList: [],
          units: [],
          address: "", // 주소
          emergencyPhone: "", // 비상연락처
          highBloodPressure: "", // 최고 혈압
          lowBloodPressure: "", // 최저 혈압
          workExperience: "0", // 경력
          smoking: "0", // 흡연 여부
          drinking: "0", // 음주 여부
          healthCheck: [],
          ppeIssueStatus: [],
          safeAgreement: [],
          pledgeConfirmed: false, // 안전 서약서 동의 여부
        });
        return { healthCheck: [], ppeIssueStatus: [] };
      } else if (response.status === 404) {
        setFormData({
          jobDate: "", // 작업 예정일
          siteId: "",
          siteName: "",
          eduId: "",
          constructionTypeList: [],
          constructionTypes: [],
          unitList: [],
          units: [],
          address: "", // 주소
          emergencyPhone: "", // 비상연락처
          highBloodPressure: "", // 최고 혈압
          lowBloodPressure: "", // 최저 혈압
          workExperience: "0", // 경력
          smoking: "0", // 흡연 여부
          drinking: "0", // 음주 여부
          healthCheck: [],
          ppeIssueStatus: [],
          safeAgreement: [],
          pledgeConfirmed: false, // 안전 서약서 동의 여부
        });
        return { healthCheck: [], ppeIssueStatus: [] };
      } else if (response.status === 200) {
        const responseData = response.data;
        // healthCheck와 ppeIssueStatus가 배열인지 확인
        if (responseData.healthCheck && !Array.isArray(responseData.healthCheck)) {
          responseData.healthCheck = [];
        }
        if (responseData.ppeIssueStatus && !Array.isArray(responseData.ppeIssueStatus)) {
          responseData.ppeIssueStatus = [];
        }

        setFormData((prev) => ({
          ...prev,
          ...responseData,
          eduId: location.state.site.id,
        }));
        return { healthCheck: responseData.healthCheck || [], ppeIssueStatus: responseData.ppeIssueStatus || [] };
      } else {
        throw new Error(response.data);
      }
    } catch (e) {
      console.log("Search error: ", e);
      return { healthCheck: [], ppeIssueStatus: [] };
    } finally {
      setLoading(false);
    }
  };

  // 건강 진단 및 보호구 지급 목록, 안전 서약 조회
  const Search1 = async (_type = "health", searchData = null) => {
    try {
      let param = "";
      if (_type === "health") {
        const healthCheckData = searchData?.healthCheck || formData.healthCheck;
        if (Array.isArray(healthCheckData) && healthCheckData.length > 0) {
          return;
        }
        param = "health_check";
      } else if (_type === "ppe") {
        const ppeIssueStatusData = searchData?.ppeIssueStatus || formData.ppeIssueStatus;
        if (Array.isArray(ppeIssueStatusData) && ppeIssueStatusData.length > 0) {
          return;
        }
        param = "ppe_issue";
      } else {
        param = "safe_agreement";
      }
      setLoading(true);
      const response = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.FormConfig, {
        companyCode: location.state.company?.companyCode,
        siteId: location.state.site?.siteId,
        formType: param,
      });
      console.log(`Search1 ${_type} response: `, response.data);

      if (!response) {
        if (_type === "health") {
          setFormData((prev) => ({
            ...prev,
            healthCheck: [],
          }));
        } else if (_type === "ppe") {
          setFormData((prev) => ({
            ...prev,
            ppeIssueStatus: [],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            safeAgreement: [],
          }));
        }
      } else if (response.status === 404) {
        if (_type === "health") {
          setFormData((prev) => ({
            ...prev,
            healthCheck: [],
          }));
        } else if (_type === "ppe") {
          setFormData((prev) => ({
            ...prev,
            ppeIssueStatus: [],
          }));
        } else {
          setFormData((prev) => ({
            ...prev,
            safeAgreement: [],
          }));
        }
      } else if (response.status === 200) {
        if (_type === "health") {
          let _healthCheck = response.data.formSchema;
          if (Array.isArray(_healthCheck)) {
            _healthCheck.forEach((item) => {
              item.checked = "";
            });
            if (!Array.isArray(formData.healthCheck) || formData.healthCheck.length < 1) {
              setFormData((prev) => ({
                ...prev,
                healthCheck: _healthCheck,
              }));
            }
          } else {
            setFormData((prev) => ({
              ...prev,
              healthCheck: [],
            }));
          }
        } else if (_type === "ppe") {
          let _ppeIssueStatus = response.data.formSchema;
          if (Array.isArray(_ppeIssueStatus)) {
            _ppeIssueStatus.forEach((item) => {
              item.checked = "";
            });
            if (!Array.isArray(formData.ppeIssueStatus) || formData.ppeIssueStatus.length < 1) {
              setFormData((prev) => ({
                ...prev,
                ppeIssueStatus: _ppeIssueStatus,
              }));
            }
          } else {
            setFormData((prev) => ({
              ...prev,
              ppeIssueStatus: [],
            }));
          }
        } else {
          setFormData((prev) => ({
            ...prev,
            safeAgreement: response.data.formSchema || [],
          }));
        }
      } else {
        throw new Error(response.data);
      }
    } catch (e) {
      console.log("Search1 error: ", e);
    } finally {
      setLoading(false);
    }
  };

  const Submit = async () => {
    try {
      setLoading(true);
      let params = {
        siteId: location.state.site?.siteId,
        companyCode: location.state.company.companyCode,
        empId: userInfo.userId,
        eduId: formData.eduId,
        jobDate: formData.jobDate,
        address: formData.address,
        phone: userInfo.tel ?? "",
        emergencyPhone: formData.emergencyPhone,
        highBloodPressure: formData.highBloodPressure,
        lowBloodPressure: formData.lowBloodPressure,
        workExperience: formData.workExperience,
        smoking: formData.smoking,
        drinking: formData.drinking,
        healthCheck: formData.healthCheck,
        ppeIssueStatus: formData.ppeIssueStatus,
        constructionTypes: formData.constructionTypes,
        units: formData.units,
        pledgeConfirmed: formData.pledgeConfirmed,
      };
      console.log("Sumit params: ", params);
      await Commons.Axios("post", Global.base.useUrl + Global.urls.Content.HealthSafety, {}, JSON.stringify(params)).then((result) => {
        let data = result.data;
        console.log("Sumit: ", data);

        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
          Swal.success("보건 서류 작성이 완료되었습니다.").then(() => {
            navigate("/composed-education", { state: { company: location.state.company, site: [] } });
          });
        }
      });
    } catch (e) {
      console.log("Sumit Error: ", e);
    } finally {
      setLoading(false);
    }
  };

  // 스텝 네비게이션 함수들
  const handleNext = () => {
    if (step < totalSteps - 1) {
      setStep(step + 1);
    }
  };

  const handlePrev = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  return (
    <div className='wrapper'>
      {loading && <Loading />}
      <div className='flex-column-start-between py-5' style={{ height: "88vh" }}>
        <StepProgress currentStep={step} totalSteps={totalSteps} stepLabels={stepLabels} />
        <StepManager currentStep={step} formData={formData} stepLabels={stepLabels} setFormData={setFormData} onNext={handleNext} onPrev={handlePrev} onSubmit={Submit} />
        <div />
      </div>
    </div>
  );
}

export default HealthInterview;
